"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutcomeInfo = void 0;
const react_redux_1 = require("react-redux");
const CommonDataProvider_1 = require("astra-core/containers/CommonDataProvider");
const EventsProvider_1 = require("astra-core/containers/EventsProvider");
const astra_core_1 = require("astra-core");
const react_1 = require("react");
const BasketProvider_1 = require("astra-core/containers/BasketProvider");
const v3_1 = require("astra-core/utils/outcomes/computeEventProbabilitiesByMarket/v3");
const getOutcomeNameInQuickBet_1 = require("astra-core/utils/outcomes/computeEventProbabilitiesByMarket/v3/getOutcomeNameInQuickBet");
const selectors_1 = require("astra-core/containers/PlayersProvider/selectors");
const selectors_2 = require("astra-core/containers/ConfigProvider/selectors");
const selectors_3 = require("astra-core/containers/CommonDataProvider/selectors");
const ConfigProvider_1 = require("astra-core/containers/ConfigProvider");
const useOutcomeInfo = (outcomeCompositeId) => {
    const { eventId, outcomeTypeId, parameters } = outcomeCompositeId;
    const outcomeKey = (0, BasketProvider_1.getBasketOutcomeKey)({
        event: { id: eventId },
        probability: {
            outcomeTypeId,
            parameters,
        },
    });
    const outcomeType = (0, react_redux_1.useSelector)((state) => (0, CommonDataProvider_1.getOutcomeTypeById)(state, outcomeTypeId));
    const { event, outcomeCategory, competitors } = (0, react_redux_1.useSelector)((state) => ({
        event: (0, EventsProvider_1.selectEventById)(state, eventId),
        outcomeCategory: (0, CommonDataProvider_1.selectOutcomeCategoryById)(state, outcomeType === null || outcomeType === void 0 ? void 0 : outcomeType.categoryId),
        competitors: (0, EventsProvider_1.selectEventCompetitors)(state, eventId),
    }));
    const virtualMarketInfosMap = (0, react_redux_1.useSelector)(selectors_3.selectVirtualMarketInfosMap);
    const config = (0, react_redux_1.useSelector)(selectors_2.selectConfig);
    const playersMap = (0, react_redux_1.useSelector)(selectors_1.selectPlayers);
    const newOutcomesEnabled = (0, ConfigProvider_1.useFeatureFlag)(ConfigProvider_1.EFeatureFlags.NEW_OUTCOMES_ENABLED);
    const newOutcomesStructEnabled = (0, ConfigProvider_1.useFeatureFlag)(ConfigProvider_1.EFeatureFlags.NEW_OUTCOMES_STRUCT_ENABLED);
    const vMarkets = (0, react_redux_1.useSelector)((state) => {
        if (outcomeType.marketId != null) {
            return (0, selectors_3.selectVMarketsByMarketId)(state, outcomeType.marketId);
        }
        else {
            return [];
        }
    });
    const vCategories = (0, react_redux_1.useSelector)(selectors_3.selectVirtualCategoriesInfo);
    const basketOutcomeName = (0, react_1.useMemo)(() => {
        if (newOutcomesStructEnabled) {
            return (0, getOutcomeNameInQuickBet_1.getOutcomeNameInQuickBet)({
                eventProbability: outcomeCompositeId,
                outcomeType,
                clientType: config.CLIENT_TYPE,
                players: playersMap,
                eventCompetitors: competitors,
                vMarkets,
                vCategories,
                sportId: event.tournament.sportId,
            });
        }
        if (newOutcomesEnabled) {
            return (0, v3_1.getOutcomeNameInBasket)(outcomeCompositeId, virtualMarketInfosMap, outcomeType, config.CLIENT_TYPE, playersMap, competitors, event.tournament.sportId);
        }
        return (0, astra_core_1.getBasketOutcomeName)({
            probWithOutcome: Object.assign(Object.assign({}, outcomeCompositeId), { outcomeTypeData: outcomeType }),
            event,
            outcomeCategory,
        });
    }, [
        newOutcomesEnabled,
        virtualMarketInfosMap,
        competitors,
        playersMap,
        config.CLIENT_TYPE,
        event,
        outcomeCategory,
        outcomeCompositeId,
        outcomeType,
    ]);
    const currentOdd = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e;
        const probabilities = (_b = (_a = event === null || event === void 0 ? void 0 : event.probabilities) === null || _a === void 0 ? void 0 : _a.markets) === null || _b === void 0 ? void 0 : _b.find((i) => i.marketId === outcomeType.marketId);
        return ((_e = (_d = (_c = probabilities === null || probabilities === void 0 ? void 0 : probabilities.probabilities) === null || _c === void 0 ? void 0 : _c.find(({ outcomeTypeId, parameters }) => {
            const key = (0, BasketProvider_1.getBasketOutcomeKey)({
                event: { id: eventId },
                probability: {
                    outcomeTypeId,
                    parameters,
                },
            });
            return key === outcomeKey;
        })) === null || _d === void 0 ? void 0 : _d.odd) !== null && _e !== void 0 ? _e : 0);
    }, [event, eventId, outcomeKey, outcomeType.marketId]);
    const competitorsNames = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        const homeNames = (_b = (_a = competitors === null || competitors === void 0 ? void 0 : competitors.homeCompetitors) === null || _a === void 0 ? void 0 : _a.map((comp) => comp.name)) === null || _b === void 0 ? void 0 : _b.join(' ');
        const awayNames = (_d = (_c = competitors === null || competitors === void 0 ? void 0 : competitors.awayCompetitors) === null || _c === void 0 ? void 0 : _c.map((comp) => comp.name)) === null || _d === void 0 ? void 0 : _d.join(' ');
        return `${homeNames} - ${awayNames}`;
    }, [competitors.awayCompetitors, competitors.homeCompetitors]);
    return (0, react_1.useMemo)(() => ({
        currentOdd,
        basketOutcomeName,
        competitorsNames,
    }), [basketOutcomeName, competitorsNames, currentOdd]);
};
exports.useOutcomeInfo = useOutcomeInfo;
//# sourceMappingURL=useOutcomeInfo.js.map